// Recovered compiled webpack factory 36934. Edit this function expression; run npm run build.
// Upstream analytics interface is inactive in the local studio.
(module, exports, require) => {
  "use strict";
  require.d(exports, { JourneyTracker: () => InactiveAnalytics });
  function InactiveAnalytics() { return null; }
}
